import { render, staticRenderFns } from "./directActivity.vue?vue&type=template&id=b6864324"
import script from "./directActivity.vue?vue&type=script&lang=js"
export * from "./directActivity.vue?vue&type=script&lang=js"
import style0 from "./directActivity.vue?vue&type=style&index=0&id=b6864324&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports